import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi } from 'ag-grid-community';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import bb from "billboard.js";
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
@Component({
    selector: 'product-template-Global',
    template: require('./productTemplateGlobal.html'),
    styles: [``]
})
export class ProductTemplateGlobalComponent implements OnInit {
    @Input('prodList1') prodList1: any;
    @Input('filterType') filterType: any;
    @Input('SerachValue') SerachValue: any;
    @Input('LastSelectedId') LastSelectedId: any;
    @Input("dValue") dvalue: any;
    @Output() SelectedProduct = new EventEmitter();
    @ViewChild('ProductNotespopup') ProductNotespopup: ElementRef;
    @ViewChild('SalesHistorypopup') SalesHistorypopup: ElementRef;
    @ViewChild('PurchaseHistorypopup') PurchaseHistorypopup: ElementRef;
    @ViewChild('MonthWiseSalespopup') MonthWiseSalespopup: ElementRef;
    @ViewChild('BatchHoldDetailspopup') BatchHoldDetailspopup: ElementRef;
    @ViewChild('SalesExpHistorypopup') SalesExpHistorypopup: ElementRef;
    @ViewChild('vendorreplacestock') vendorreplacestock: ElementRef

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService,BsDatepickerConfig,CommonFunction]
    dateFormat: any;
    bsConfig: any;
    constructor(public utilityService: UtilityService, public http: HttpClient,private modalService : NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig,public commonFunction : CommonFunction) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;

        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.dateFormat.dateInputFormat, containerClass: this.dateFormat.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.dateFormat.dateInputFormat;
      //   console.log("this.bsConfig", this.bsConfig);
    }
    
    gridApiPrd: any;
    gridColumnApiPrd: any;
    selectedProductInfo: any;
    prodList: any;
    paginationConf: any;
    d: any;
    productListDef: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    ProductStock: any;
    TblProductStock: any;
    modalReference: NgbModalRef;
    public orderSearch2: any;
    //filterType:any;
    SortedProdList:any;
    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });
    public hotkeyList: Hotkey[];
    public orderSearch: any;

    ngOnInit(): void {
      //   console.log('product template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = UserSettings.enablePagination;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.ProductStock = 0;
        this.TblProductStock = [];
        this.SortedProdList = [];
        this.initHotkeys();
        this.orderSearch = {};
        this.orderSearch2 = {};
        this.orderSearch.filtertype = 'C';
        this.orderSearch.From_Date = new Date();
        this.orderSearch.To_Date = new Date();
        this.orderSearch2.From_Date = this.oneMonthAgo();
        this.orderSearch2.To_Date = new Date();
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    initHotkeys() {
        this.hotkeyList = [];
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Product_Code"]').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Product_Desc"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const altu = new Hotkey('alt+u', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Manufacturer_Name"]').trigger('click');
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altu);
        this.hotkeysService.add(altu);

        const altl = new Hotkey('alt+l', (event: KeyboardEvent): boolean => {
            this.filterProducts(event,"");
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altl);
        this.hotkeysService.add(altl);

        const alts = new Hotkey('alt+s', (event: KeyboardEvent): boolean => {
            this.filterProducts(event,"Substitute");
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alts);
        this.hotkeysService.add(alts)

        const alti = new Hotkey('alt+i', (event: KeyboardEvent): boolean => {
            this.filterProducts(event,'NewItems');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(alti);
        this.hotkeysService.add(alti)

        const altp = new Hotkey('alt+p', (event: KeyboardEvent): boolean => {
           this.filterProducts(event,'Promotional');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altp);
        this.hotkeysService.add(altp)

        const altt = new Hotkey('alt+t', (event: KeyboardEvent): boolean => {
           this.OpenProductNotesPopup(this.ProductNotespopup);
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altt);
        this.hotkeysService.add(altt);

        const altb = new Hotkey('alt+b', (event: KeyboardEvent): boolean => {
            this.OpenBatchHoldDetailspopup(this.BatchHoldDetailspopup);
             return false;
         }, ['INPUT', 'SELECT', 'TEXTAREA']);
         this.hotkeyList.push(altb);
         this.hotkeysService.add(altb);

         const alth = new Hotkey('alt+h', (event: KeyboardEvent): boolean => {
            this.OpenSalesHistoryPopup(this.SalesHistorypopup);
             return false;
         }, ['INPUT', 'SELECT', 'TEXTAREA']);
         this.hotkeyList.push(alth);
         this.hotkeysService.add(alth);

         const altr = new Hotkey('alt+r', (event: KeyboardEvent): boolean => {
            this.OpenPurchaseHistorypopup(this.PurchaseHistorypopup);
             return false;
         }, ['INPUT', 'SELECT', 'TEXTAREA']);
         this.hotkeyList.push(altr);
         this.hotkeysService.add(altr);

         const altm = new Hotkey('alt+m', (event: KeyboardEvent): boolean => {
            this.OpenMonthWiseSalespopup(this.MonthWiseSalespopup);
             return false;
         }, ['INPUT', 'SELECT', 'TEXTAREA']);
         this.hotkeyList.push(altm);
         this.hotkeysService.add(altm);

         const altx= new Hotkey('alt+x', (event: KeyboardEvent): boolean => {
            this.OpenSalesExpHistorypopup(this.SalesExpHistorypopup);
             return false;
         }, ['INPUT', 'SELECT', 'TEXTAREA']);
         this.hotkeyList.push(altx);
         this.hotkeysService.add(altx);

         const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc);

        const shiftr = new Hotkey('shift+r', (event: KeyboardEvent): boolean => {
            //$('.toggle-arrow-forup').trigger('click');
            this.ReplacementStockListRefModal(this.vendorreplacestock);
            return false; // Prevent bubbling
            }, ['INPUT', 'SELECT', 'TEXTAREA']);
            this.hotkeyList.push(shiftr);
            this.hotkeysService.add(shiftr);
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }

    onGridReadyPrd(params) {
        var parent = this;
        $( "#prodfilter-text-box").keypress(function(event) {
            if (event.keyCode == 13) {
                parent.custSelectionMain(parent);
            }
        });

        $(".radio-label").change(function () {
            var select = $(this).val();
            $("input#prodfilter-text-box").val("");
            self.gridApiPrd.setFilterModel(null);
            self.gridApiPrd.onFilterChanged();
            if (select == 'Product_Code') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Code").blur();
            } else if (select == 'Product_Desc') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Name").blur();
            } else if (select == 'Manufacturer_Name') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Manufacturer").blur();
            }
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        });
        if(!this.filterType){
            this.filterType = "Product_Desc";
        }
        var parent = this;
        $(document).ready(function(){
            if (parent.filterType == 'Product_Code') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Code").blur();
            } else if (parent.filterType == 'Product_Desc') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Name").blur();
            } else if (parent.filterType == 'Manufacturer_Name') {
                $("input[id=prodfilter-text-box]").attr("placeholder", "Search Product By Manufacturer").blur();
            }
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        });
        this.productListDef = [
            // { headerName: 'ID', field: 'Product_ID', width: 70, },
            { headerName: 'Code', field: 'Product_Code', width: 125, },
            { headerName: 'Name', field: 'Product_Desc', width: 220, },
            { headerName: 'Packsize', field: 'Packsize', width: 100, },
            //{ headerName: 'MRP', field: 'MRP', width: 83, cellStyle: {'text-align': 'right'} },
            //{ headerName: 'Rate', field: 'Rate', width: 87, },
            //{ headerName: 'PTR', field: 'PTR', width: 75, cellStyle: {'text-align': 'right'} },
            { headerName: 'Unit', field: 'Base_Unit', width: 100 },
            { headerName: 'Per Box', field: 'perbox', width: 75 },
            { headerName: 'Manufacturer', field: 'Manufacturer_Name', width: 170, enableCellChangeFlash: true },
            { headerName: 'Division', field: 'Division_Name', width: 150, enableCellChangeFlash: true },
            //{ headerName: 'Alt Code', field: 'altCode', width: 93, enableCellChangeFlash: true },
        ];
      //   console.log('prdList1', this.prodList1);
        this.prodList = this.prodList1;
        this.gridApiPrd = params.api;
        setTimeout(() => {
            this.gridColumnApiPrd = params.columnApi;
            this.gridApiPrd.sizeColumnsToFit();
            var index = 0;
          //   console.log('this.SerachValue : ',this.SerachValue);
            if (this.LastSelectedId) {
                index = this.prodList1.map(item => item.Product_ID).indexOf(this.LastSelectedId);
                if (this.gridApiPrd.getInfiniteRowCount() < index) {
                    this.gridApiPrd.setInfiniteRowCount(index, false);
                }
                this.gridApiPrd.ensureIndexVisible(index);
                this.gridApiPrd.setFocusedCell(index, "Product_Code");
            }
            $('#prodfilter-text-box').focus().select();
            if(this.SerachValue){
                this.searchValue = this.SerachValue;
                this.quickSearch("", "product");
            } else {
                this.selectedProductInfo = this.gridApiPrd.getModel().getRow(index).setSelected(true);
            }
            if ("ProductSearch" in localStorage) {
                let localStorageData = localStorage.getItem('ProductSearch');
                localStorage.removeItem('ProductSearch');
                if(localStorageData){
                    this.searchValue = localStorageData;
                    this.quickSearch("", "product");
                }
            }
        }, 100);
        var myInput = document.getElementById("productmaster");
        let self = this;
        this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
        this.defaultColDef = {
            resizable: true,
            sortable: true,
        };
        // setTimeout(() => {

        //     this.gridColumnApiPrd.autoSizeAllColumns();

        // }, 1000);
    }
    gridEventDown(event) {
        if (event.keyCode == 13) {
          //   console.log("keydown", event);
            this.custSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#prodfilter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#prodfilter-text-box').focus().select();
        }
    }
    private custSelectionMain(self: this) {
        let selectedRows = self.gridApiPrd.getSelectedRows();
        let cust = selectedRows[0];
      //   console.log("selected cust:", selectedRows[0]);
        if ("ProductSearch" in localStorage) {
            localStorage.removeItem('ProductSearch');
        }
        if(this.searchValue){
            localStorage.setItem('ProductSearch', this.searchValue);
        }
        if (cust != undefined) {
            cust.filterType = this.filterType;
            if (this.httpCalling.isStopped) {
                cust.WareHouseData = this.TblProductStock;
              //   console.log('stopped selected ccustomer :', cust);
                this.SelectedProduct.emit(cust);
            } else {
                let dataWare = { "Product_ID": cust.Product_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID };
                this.http.get(`/api/${this.unitInfo.Company_Code}/products/GET_PRODUCT_STOCK`, { params: dataWare })
                    .subscribe(result => {
                        this.TblProductStock = result;
                        cust.WareHouseData = this.TblProductStock;
                      //   console.log('not stopped selected ccustomer:', cust);
                        this.SelectedProduct.emit(cust);
                    });
            }
        }
    }

    invoiceInfo: any;
    productFilterd: any;
    httpCalling: any;
    SaltMolecule : any;
    Division_Name : any;
    Category_Name:  any;
    HSN_igst:  any;
    VendorReplacementStockList: any;
    prodSelected(event) {
        this.VendorReplacementStockList =[];
        let selectedRowCust = this.gridApiPrd.getSelectedRows();
      //   console.log("selectedRows", selectedRowCust);
        this.selectedProductInfo = selectedRowCust[0];
        this.SetProductDetails(this.selectedProductInfo);
        let dataWare = { "Product_ID": selectedRowCust[0].Product_ID, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID };
        if(this.httpCalling && this.httpCalling.isStopped == false){
            this.httpCalling.unsubscribe();
        }
        this.httpCalling = this.http.get(`/api/${this.unitInfo.Company_Code}/products/GET_PRODUCT_STOCK`, { params: dataWare })
            .subscribe(result => {
                this.TblProductStock = result;
                this.ProductStock = this.TblProductStock.reduce(function (acc, sum) {
                    return acc + parseInt(sum.available);
                }, 0);
            });
        this.GetReplacementStock();
    }

    SetProductDetails(selectedProductInfo) {
        this.SaltMolecule = selectedProductInfo.Molecule_Desc;
        this.Division_Name = selectedProductInfo.Division_Name;
        this.Category_Name = selectedProductInfo.Category_Name;
        this.HSN_igst = selectedProductInfo.HSN_igst;
        this.ProductStock = 0;
        this.TblProductStock = [];
    }

    onProdSelectionChanged(event) {
        this.custSelectionMain(this);
    }
    /* quickSearch(event, id) {
        if (id == 'product') {
            this.gridApiPrd.setQuickFilter(this.searchValue);
            this.gridApiPrd.onFilterChanged();
            this.gridApiPrd.getModel().getRow(0).setSelected(true);
            this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiPrd.setFocusedCell(0, "Product_Code");
            }
        }
    } */
    quickSearch(event, id) {
        if (id == 'product') {
            // this.gridApi.setQuickFilter(this.filterValue);
            var sportsFilterComponent = this.gridApiPrd.getFilterInstance(this.filterType);
            if(this.searchValue){
                let search = this.searchValue;//.split(' ');
                sportsFilterComponent.setModel({
                    type: "contains",
                    filter: search
                });
            } else {
                this.gridApiPrd.setFilterModel(null);
            }
            this.gridApiPrd.onFilterChanged();
            if (this.gridApiPrd.getModel().getRowCount() > 0) {
                this.gridApiPrd.getModel().getRow(0).setSelected(true);
            }
            this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiPrd.setFocusedCell(0, "Product_Code");
            }
        }
    }

    close(){
        this.modalService.dismissAll();
    }

    CommonList:any;
    GetProductNotes(ProductId){
        this.CommonList = [];
        let data = {"Product_ID": ProductId};
        this.http.post('api/Salesinvoices/GET_Product_NOTES', data)
        .subscribe(Response=>{
            this.CommonList = Response;
        });
    }

    CommoncolumnDefs:any;
    OpenProductNotesPopup(ProductNotespopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(ProductNotespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth' });
        this.GetProductNotes(this.selectedProductInfo.Product_ID);
        this.CommoncolumnDefs = [
            {headerName: 'Description', field: 'Notes_Description'},
            {headerName: 'Date', field: 'Notes_Date', width:50}
        ]
    }

    toastWarningMsg(msg) {
        this.toast({
            type: 'warning',
            title: msg,
            timer: 3000
        });
    }

    gridCommonApi:GridApi;
    gridCommonColumnApi:ColumnApi;
    CommondetailsGridApi(params){
        this.gridCommonApi = params.api;
        this.gridCommonColumnApi = params.columnApi;
        // setTimeout( () => {
        //     this.gridCommonApi.sizeColumnsToFit();
        // }, 100);
    }

    CopyArrayList(array: any){
        var arr = [];
        array.forEach(element => {
            var x = Object.assign({}, element);
            arr.push(x);
        });
        return arr;
    }

    filterProducts(event, filterType){
        $(".button-link").removeClass('active');
        // $('#'+event.target.id).toggleClass('active'); 
        if(filterType == "Substitute"){
            var Molecule_Desc = this.selectedProductInfo? this.selectedProductInfo.Molecule_Desc: "";
            var ProductId = this.selectedProductInfo? this.selectedProductInfo.Product_ID: "";
            this.prodList = this.prodList1.filter(function(item){
                return item.Molecule_Desc == Molecule_Desc && item.Molecule_Desc != "" && item.Product_ID != ProductId
            });
        } else if(filterType == "NewItems"){
            if(this.SortedProdList.length == 0) {
                this.prodList = this.CopyArrayList(this.prodList1);
                this.SortedProdList = this.prodList.sort((val1, val2)=> {return <any>new Date(val2.CreatedOn) - <any>new Date(val1.CreatedOn)})
            }
            this.prodList = [];
            for(var i = 0; i < 20; i++){
                this.prodList.push(this.SortedProdList[i]);
            }
        } else if(filterType == "Promotional"){            
            this.prodList = this.prodList1.filter(function(item){
                return item.Is_Promotional == 1
            });
        } else {
            this.prodList = this.prodList1;
        }
        this.selectedProductInfo = {};
        this.SetProductDetails(this.selectedProductInfo);
        setTimeout(() => {
            $('#prodfilter-text-box').focus().select();
            this.quickSearch("", "product");
            if (this.gridApiPrd.getModel().getRowCount() > 0) {
                this.selectedProductInfo = this.gridApiPrd.getModel().getRow(0).setSelected(true);
                this.gridApiPrd.setFocusedCell(0, "Product_Code");
            }
        }, 100);
    }

    OpenSalesHistoryPopup(SalesHistorypopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        
        this.modalService.open(SalesHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup' });
       
      //  $('.ProductPopup input#From_Date').focus().select();
        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            {headerName: 'Code', field: 'Customer_Code', width: 100 },
            {headerName: 'Name', field: 'Customer_Name', width: 180 },
            {headerName: 'Area', field: 'Area_Name', width: 120 },
            {headerName: 'City', field: 'City_Desc', width: 120 },
            {headerName: 'Inv No', field: 'Invoice_No', width: 120 },
            {headerName: 'Inv Date', field: 'Invoice_Date', width: 100 },
            {headerName: 'Batch No', field: 'Batch_No', width: 100 },
            {headerName: 'Exp Date', field: 'Expiry_Date', width: 80 },
            {headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'MRP', field: 'MRP', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'PTR', field: 'PTR', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Rate', field: 'Rate', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: {'text-align': 'right'} },
        ]

        this.CommonList=[];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "S",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }

    GetPurchaseOrSalesHistory(ProductId, HistoryType,From_Date,To_Date){
        if (this.orderSearch.To_Date < this.orderSearch.From_Date) {
            this.toastWarningMsg("To Date cannot be less than From Date");
        }
        else {
            if (this.orderSearch.To_Date != null || this.orderSearch.From_Date != null) {
        this.CommonList = [];
        let data = {"Product_ID": ProductId, "Type": HistoryType, "Unit_ID": this.unitInfo.Unit_ID, "Company_ID": this.unitInfo.Company_ID, "From_Date":From_Date,"To_Date":To_Date
        // "FYear": this.unitInfo.CurrentFYear
    };
        this.http.post('api/Salesinvoices/Get_Product_History', data)
        .subscribe(Response=>{
            this.CommonList = Response;
            if(HistoryType == 'B'){
                setTimeout( () => {
                    this.gridCommonApi.sizeColumnsToFit();
                }, 100);
            }
            if(HistoryType == 'M'){
                this.Barchart.load({
                    json: this.CommonList
                });
            }

            if(!this.CommonList){
                $('input[name=From_Date]').focus();
            }
        });
    }}
    }

    OpenPurchaseHistorypopup(PurchaseHistorypopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
       
        // this.modalReference = this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});
        // this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "P",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));

        this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});

        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            {headerName: 'Code', field: 'Vendor_Code', width: 100 },
            {headerName: 'Name', field: 'Vendor_Name', width: 180 },
            {headerName: 'City', field: 'City_Desc', width: 100 },
            {headerName: 'Inv No', field: 'Doc_No', width: 150 },
            {headerName: 'Inv Dt', field: 'Doc_Date', width: 100 },
            {headerName: 'Batch No', field: 'Batch_No', width: 100 },
            {headerName: 'Exp Dt', field: 'Expiry_Date', width: 80 },
            {headerName: 'Qty', field: 'Entry_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'FQty', field: 'Free_Qty', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'MRP', field: 'MRP', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'PTR', field: 'PTR', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Rate', field: 'Rate', width: 100, cellStyle: {'text-align': 'right'} },
            {headerName: 'Disc', field: 'Discount_Per', width: 70, cellStyle: {'text-align': 'right'} },
            {headerName: 'Taxable Amt', field: 'Taxable_Amount', width: 100, cellStyle: {'text-align': 'right'} },
        ]
        this.CommonList=[];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "S",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }

    OpenSalesExpHistorypopup(SalesExpHistorypopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
       
        // this.modalReference = this.modalService.open(PurchaseHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});
        // this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "P",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));

        this.modalService.open(SalesExpHistorypopup, { size: 'lg', windowClass: 'data-show ProductPopup'});

        $('input[name=From_Date]').focus().select();

        this.CommoncolumnDefs = [
            {headerName: 'Sr. No.', field: 'SR_NO', width: 50 },
            {headerName: 'Date', field: 'Invoice_Date', width: 100 },
            {headerName: 'Trans. No', field: 'Invoice_No', width: 150 },
            {headerName: 'Trans. Type', field: 'Transaction_Type', width: 150 },
            {headerName: 'Name', field: 'Customer_Name', width: 180 },
            {headerName: 'Batch No', field: 'Batch_No', width: 100 },
            {headerName: 'RCVD', field: 'RCVD', width: 100 },
            {headerName: 'Issue', field: 'Issue', width: 100 },
            {headerName: 'Balanace', field: 'Balance', width: 100 },
        ]
        this.CommonList=[];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "X",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
    }


    OpenMonthWiseSalespopup(MonthWiseSalespopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(MonthWiseSalespopup, { size: 'lg', windowClass: 'data-show width75 accountposting updateWarehouseWidth'});
        this.genrateBarChart();
        this.CommonList=[];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "M",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
        // this.CommoncolumnDefs = [
        //     {headerName: 'Month', field: 'Month', width: 200},
        //     {headerName: 'Sales Amount', field: 'Sales_Amount', width: 150, cellStyle: {'text-align': 'right'}}
        // ]
    }
    
    Barchart:any;
    genrateBarChart(){
        this.Barchart = bb.generate({
           bindto: "#chart",
           data: {
                json: [],
                type: "bar",
                "colors": {
                    "Sales": "#0000FF",
                    "Purchase": "#f0b205"
                },
                keys: {
                    x: "Month",
                    value: ["Sales", "Purchase"],
                }
            },           
            axis: {
                x: {
                    type: "category",                        
                }
            },
            bar : { 
                width : {
                    ratio : 1,
                    max : 20
                }
            },
        });
    }
    
    
    OpenBatchHoldDetailspopup(BatchHoldDetailspopup){
        if(!this.selectedProductInfo.Product_ID){
            this.toastWarningMsg("Product Not Selected");
            return;
        }
        this.modalReference = this.modalService.open(BatchHoldDetailspopup, { size: 'lg', windowClass: 'data-show ProductPopup'});
        this.CommonList=[];
        this.GetPurchaseOrSalesHistory(this.selectedProductInfo.Product_ID, "B",moment(this.orderSearch.From_Date).format('YYYY-MM-DD'),moment(this.orderSearch.To_Date).format('YYYY-MM-DD'));
        this.CommoncolumnDefs = [
            {headerName: 'Batch No', field: 'Batch_No', width: 150},
            {headerName: 'Expiry Date', field: 'Expiry_Date', width: 100},
            {headerName: 'MFG Date', field: 'MFG_Date', width: 100},
            {headerName: 'Hold Qty', field: 'Hold_Qty', width: 100, cellStyle: {'text-align': 'right'}},
            {headerName: 'Bin', field: 'Bin', width: 100},
            {headerName: 'Warehouse', field: 'Warehouse_Code', width: 150},
        ]
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }
    From_Datechange(e){
        if(e.which == 13){
            $('#To_Date').focus();
        }
    }

    To_Datechange(e){
      //   console.log("e.which",e.which);
        if(e.which == 13){
            $('#okbtn1').focus();
        }

    }

    
    onDateSelect(event, id) {
        // console.log("event", event);
        // console.log("self", self);
        $(id).focus();
    }

    clearAllFilter() {
        this.searchValue = '';
    }

     /* Replacement Stock List Start */
	
	GetReplacementStock(){
    //var id = this.selectedVendor['Vendor_ID'];
        var listID = [{ "Vendor_ID": 0 , "Type" : "Product", "Product_ID" : this.selectedProductInfo.Product_ID ,"FromDate": this.orderSearch2.From_Date , "ToDate": this.orderSearch2.Date}];
        this.http.post('/api/vendors/GetVendorReplacementStock', listID)
        .subscribe(result=>{
          //   console.log(result);
            
            this.VendorReplacementStockList = result;
            this.TotalTotalReplacementStcok = this.VendorReplacementStockList.reduce(function(acc, sum){
            //return acc + Number(sum.Outstanding? sum.Outstanding: 0);
            return acc + (parseInt(sum.r_Qty));
            }, 0);
                
            this.TotalReplacementStcokValue = this.VendorReplacementStockList.reduce(function(acc, sum){
            //return acc + Number(sum.Outstanding? sum.Outstanding: 0);
            return acc + (parseFloat(sum.total_amt));
            }, 0);
        });
    }
    ReplacementStockListRef: NgbModalRef;
    ReplacementStockListcolumnDefs: any;
    TotalReplacementStcokValue: any;
    TotalTotalReplacementStcok: any;
    ReplacementStockListRefModal(vendorreplacestock) {
            
    this.modalService.open(vendorreplacestock, { size: 'sm', windowClass: 'data-show ledger' });
            
    this.ReplacementStockListcolumnDefs = [
    
        { headerName: 'Doc. No', field: 'TransNo'},
        { headerName: 'Doc. Date', field: 'Doc_Date'},
        { headerName: 'Qty', field: 'Entry_Qty'},
        { headerName: 'R. Qty', field: 'r_Qty'},
        { headerName: 'Batch No', field: 'Batch_No'},
        { headerName: 'Rate', field: 'Rate', },
        { headerName: 'Amount', field: 'total_amt', width: 100 },
        ];
    
            
    }
    public gridApiReplacementStock: any;
    public gridColumnApiReplacementStock: any;
    ReplacementStockGridReady(params) {
    this.gridApiReplacementStock = params.api;
    this.gridColumnApiReplacementStock = params.columnApi;
    this.gridApiReplacementStock.sizeColumnsToFit();
    }
    /* Replacement Stock List End */
        
    NavigateScreen(event){
        var parent = this;
        var self = this;
      //   console.log("Column Data :::: ", event.column.colId);
      //   console.log("Column Data :::: ", event.column.userProvidedColDef.field);
        
        if (event.column.colId == "TransNo" || event.column.userProvidedColDef.field == "TransNo"){
            if((Number(event.data.Transaction_No) ? Number(event.data.Transaction_No) : 0) > 0){
              //   console.log("Naivgation Data :::: ", event.data);
                var data_navi = {"ScreenType" : Number(event.data.Transaction_Type) ,"Transaction_No" : Number(event.data.Transaction_No)}
                parent.commonFunction.Nevigate_Document_Entry(data_navi);
            }
        }
                
        if (event.column.colId == "Doc_No" || event.column.userProvidedColDef.field == "Doc_No") // only first column clicked
        {
            if((Number(event.data.Transaction_No) ? Number(event.data.Transaction_No) : 0) > 0){
              //   console.log("Naivgation Data :::: ", event.data);
                var data_navi = {"ScreenType" : Number(8) ,"Transaction_No" : Number(event.data.Transaction_No)}
                parent.commonFunction.Nevigate_Document_Entry(data_navi);
            }
        }
            
    }   

    
}

